import React from "react";
import { Stack, Typography } from "@mui/material";

const MarketPriceSection = ({ title, children, width = 450, titleWidth = 160, sx }) => {
    return (
        <Stack
            display="flex"
            alignItems="baseline"
            direction="row"
            spacing={2}
            padding={2}
            width={width}
            sx={{ ...sx }}
        >
            <Typography sx={{ fontSize: '20px', textAlign: "left", width: titleWidth }}>
                {title}
            </Typography>
            {children}
        </Stack>
    );
};

export default MarketPriceSection;
